import type { MealPlanResponse, MealResponse } from 'api/components/Nutrition';

import * as actionTypes from './actionTypes';

export const getMealById = (payload: { mealId: number }) => {
    return {
        type: actionTypes.GET_MEAL_BY_ID,
        payload,
    } as const;
};

export const setMeal = (payload: MealResponse) => {
    return {
        type: actionTypes.SET_MEAL,
        payload,
    } as const;
};

export const getMealPlan = (date: string) => {
    return {
        type: actionTypes.GET_MEAL_PLAN,
        payload: { date },
    } as const;
};

export const setMealPlan = (payload: MealPlanResponse) => {
    return {
        type: actionTypes.SET_MEAL_PLAN,
        payload,
    } as const;
};

export const setLoadingState = (payload: boolean) => {
    return {
        type: actionTypes.SET_LOADING_STATE,
        payload,
    } as const;
};
